import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
  selector: 'ui-radio-card',
  standalone: true,
  imports: [RadioButtonModule, FormsModule],
  templateUrl: './ui-radio-card.html',
  styleUrl: './ui-radio-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiRadioCardStandalone),
      multi: true
    }
  ]
})
export class UiRadioCardStandalone implements ControlValueAccessor, OnChanges {
  @Input() disabled: boolean = false;
  @Input() inputId: string = '';
  @Input() name: string = '';
  @Input() title: string = '';
  @Input() radioValue: any = false;
  @Input() selectedValue: any = undefined;
  /** Если true — клик по телу/заголовку раскрывает (emit expand), а выбор только по самому кружку. */
  @Input() expandable: boolean = false;
  @Output() onClick = new EventEmitter<any>();
  @Output() expand = new EventEmitter<void>();

  private controlled = false;

  private _value: any = false;
  get value(): any {
    return this._value;
  }

  get effectiveValue(): any {
    return this.controlled ? this.selectedValue : this._value;
  }

  get checked(): boolean {
    return this.effectiveValue === this.radioValue;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedValue']) {
      this.controlled = true;
    }
  }

  set value(val: any) {
    if (this._value !== val) {
      this._value = val;
      this.onChangeCallback(val);
    }
  }

  private onChangeCallback: (value: any) => void = () => {};
  private onTouchedCallback: () => void = () => {};

  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: any): void {
    this._value = value;
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onRadioChange(event: any) {
    const selectedValue = event.value !== undefined ? event.value : event;
    this.onTouchedCallback();
    this.onClick.emit(selectedValue);
  }

  onCardClick(event?: MouseEvent) {
    if (this.expandable) {
      // Клик по кружку (или его расширенной зоне) — выбор группы;
      // клик по остальной части карточки/заголовку — раскрывает вложенные.
      // Раскрывать можно даже у disabled-группы (disabled запрещает только выбор).
      const target = event?.target as HTMLElement | null;
      if (target?.closest('p-radiobutton')) {
        if (!this.disabled) {
          this.onTouchedCallback();
          this.onClick.emit(this.radioValue);
        }
        return;
      }
      this.expand.emit();
      return;
    }

    if (this.disabled) return;
    this.value = this.radioValue;
    this.onTouchedCallback();
    this.onClick.emit(this.radioValue);
  }
}
